import React, { MouseEvent, ReactNode } from 'react';
import { Button } from '../Button/Button';
import './DropdownMenuItem.scss';
import classnames from 'classnames';

type OuterProps = {
  icon?: string | ReactNode;
  name: string;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
};

export const DropdownMenuItem = ({
  icon,
  name,
  onClick,
  className,
}: OuterProps) => (
  <Button
    css={{ container: classnames('dropdown-menu__item', className) }}
    onClick={onClick}
    onMouseDown={(e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
    }}
  >
    {typeof icon === 'string' ? (
      <img src={icon} alt="" className="dropdown-menu__item-icon" />
    ) : (
      icon
    )}
    {name && <span className="dropdown-menu__item-name">{name}</span>}
  </Button>
);
